import {
  buildGoogleFontsStylesheetHref,
  collectTypographyPresetFontFamilies,
} from '@web-studio/shared-schemas';

/** Ensure every THEME_REGISTRY typography preset can render in Design Lab previews. */
export function ensureThemePreviewFontsLoaded(): void {
  if (typeof document === 'undefined') return;
  const href = buildGoogleFontsStylesheetHref(collectTypographyPresetFontFamilies());
  if (!href) return;
  const existing = document.querySelector<HTMLLinkElement>('link[data-ws-theme-fonts="1"]');
  if (existing) {
    existing.href = href;
    return;
  }
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = href;
  link.dataset.wsThemeFonts = '1';
  document.head.appendChild(link);
}
